import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { loadDeliveryInfo, selectDeliveryLoading } from '../features/delivery/deliverySlice';
import MyAccountNav from '../components/MyAccountNav';
import MyOrders from '../features/orders/MyOrders';
import MyOrdersMobile from '../features/orders/MyOrdersMobile';
import Window from '../utils/Window';
import { selectToken } from '../features/user/userSlice';
import MyAccountPage from './MyAccountPage';
import MenuButton from '../app/styles/components/MenuButton';

export default function MyOrdersPage() {
  const dispatch = useDispatch();
  const [deliveryReloaded, setDeliveryReloaded] = useState(false);
  const deliveryLoading = useSelector(selectDeliveryLoading);
  const token = useSelector(selectToken);

  useEffect(() => {
    if (!deliveryLoading && !deliveryReloaded) {
      dispatch(loadDeliveryInfo());
      setDeliveryReloaded(true);
    }
  }, [deliveryLoading, deliveryReloaded, dispatch]);

  if (!token) {
    return (
      <MyAccountPage />
    )
  }

  return (
    <Container fluid="lg" className='address-page'>
      <Row>
        {Window.isMobile() ?
          <>
            <Col xs={3} className='p-0 px-2 pt-2'>
              <MenuButton />
            </Col>
            <Col xs={9} className='p-0 px-3 d-flex align-items-center justify-content-end'>
              <span className="text-uppercase fw-400 fs-35px font-league-gothic">My Orders</span>
            </Col>
          </> :
          <Col sm={12} md={3}>
            <MyAccountNav />
          </Col>}
        <Col sm={12} md={9} className='d-flex flex-column'>
          {Window.isMobile() ? <MyOrdersMobile /> : <MyOrders />}
        </Col>
      </Row>
    </Container>
  );
}
